import moment from 'moment'

// Status mapping
export const STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'paused', label: 'Paused' },
  { value: 'not_opened', label: 'Not Opened' }
]

export const formatArcAdForApi = (values) => {
  const data = {
    type: 'arc_ads',
    attributes: {
      banner_id: values.banner_id,
      campaign_id: values.campaign_id,
      header: values.header,
      short_description: values.short_description,
      description: values.description,
      terms_url: values.terms_url,
      beacon_url: values.beacon_url,
      click_url: values.click_url,
      cta_text: values.cta_text,
      status: values.status?.value || values.status,
      source: values.source_id.value,
      footer_text: values.footer_text,
      footer_policy_text: values.footer_policy_text,
      footer_policy_url: values.footer_policy_url,
      started_at: values.started_at,
      end_at: values.end_at,
      hero_width: values.hero_width,
      hero_height: values.hero_height,
      icon_width: values.icon_width,
      icon_height: values.icon_height
    },
  }

  if (values.countries !== undefined) {
    data.attributes.countries = values.countries?.map(country => country.value || country) || []
  }

  if (values.icon_url_base64) {
    data.attributes.icon_url_base64 = values.icon_url_base64
    data.attributes.icon_width = values.icon_width || 150
    data.attributes.icon_height = values.icon_height || 150
  }

  if (values.hero_url_base64) {
    data.attributes.hero_url_base64 = values.hero_url_base64
    data.attributes.hero_width = values.hero_width || 600
    data.attributes.hero_height = values.hero_height || 400
  }

  if (values.arc_advertiser_id) {
    data.relationships = {
      arc_advertiser: {
        data: { type: 'arc_advertisers', id: values.arc_advertiser_id?.value || values.arc_advertiser_id }
      }
    }
  }

  return data
}

export const formatArcAdForForm = (ad, included = []) => {
  if (!ad) return {}
  // Find the advertiser from included data
  const advertiser = included?.find(item =>
    item.type === 'arc_advertisers' &&
    item.id === ad.relationships?.arc_advertiser?.data?.id
  )

  return {
    id: ad.id,
    banner_id: ad.attributes.banner_id,
    campaign_id: ad.attributes.campaign_id,
    header: ad.attributes.header,
    short_description: ad.attributes.short_description,
    description: ad.attributes.description,
    terms_url: ad.attributes.terms_url,
    beacon_url: ad.attributes.beacon_url,
    click_url: ad.attributes.click_url,
    cta_text: ad.attributes.cta_text,
    icon_url: ad.attributes.icon_url,
    icon_width: ad.attributes.icon_width,
    icon_height: ad.attributes.icon_height,
    hero_url: ad.attributes.hero_url,
    hero_width: ad.attributes.hero_width,
    hero_height: ad.attributes.hero_height,
    arc_advertiser_id: ad.relationships?.arc_advertiser?.data?.id,
    advertiser_name: advertiser?.attributes?.name,
    status: ad.attributes.status,
    source_id: ad.attributes.source,
    footer_text: ad.attributes.footer_text,
    footer_policy_text: ad.attributes.footer_policy_text,
    footer_policy_url: ad.attributes.footer_policy_url,
    started_at: ad.attributes.started_at,
    end_at: ad.attributes.end_at,
    countries: ad.attributes.countries || []
  }
}

export const formatArcAdForTable = (ad, included = []) => {
  if (!ad) return {}
  const advertiser = included?.find(item =>
    item.type === 'arc_advertisers' &&
    item.id === ad.relationships?.arc_advertiser?.data?.id
  )
  const isExpired = ad.attributes.end_at && moment().isAfter(moment(ad.attributes.end_at))

  const statusOption = STATUS_OPTIONS.find(option => option.value === ad.attributes.status)

  return {
    key: ad.id,
    id: ad.id,
    header: ad.attributes.header,
    description: ad.attributes.description,
    cta_text: ad.attributes.cta_text,
    icon_url: ad.attributes.icon_url,
    hero_url: ad.attributes.hero_url,
    advertiser_name: advertiser?.attributes?.name || 'N/A',
    advertiser_id: advertiser?.id,
    status: ad.attributes.status,
    isExpired: isExpired,
    source: ad.attributes.source_id,
    started_at: ad.attributes.started_at ? moment(ad.attributes.started_at).format('YYYY-MM-DD HH:mm') : 'N/A',
    end_at: ad.attributes.end_at ? moment(ad.attributes.end_at).format('YYYY-MM-DD HH:mm') : 'N/A',
    countries: ad.attributes.countries || [],
    created_at: moment(ad.attributes.created_at).format('YYYY-MM-DD HH:mm'),
    updated_at: moment(ad.attributes.updated_at).format('YYYY-MM-DD HH:mm'),
  }
}